const VISITOR_ID_KEY = 'sparkapp_vid';

export function getOrCreateVisitorId(): string {
  const existing = localStorage.getItem(VISITOR_ID_KEY);
  if (existing) return existing;
  const newId = crypto.randomUUID?.() ?? Array.from(self.crypto.getRandomValues(new Uint8Array(16))).reduce<string>((s, b, i) => s + ([4, 6, 8, 10].includes(i) ? '-' : '') + b.toString(16).padStart(2, '0'), '');
  localStorage.setItem(VISITOR_ID_KEY, newId);
  return newId;
}

export function getVisitorId(): string | null {
  return localStorage.getItem(VISITOR_ID_KEY);
}
